import {
    getOrigin,
    getQueryStringValue,
    NavigationListNames,
    NavigationListTypes,
    parseFrefStyleFindingMethod,
} from '@libs/common-next';

import { TrackingParams } from '../constants/trackingParams';

export const getNavigationName = (findingMethod: string) => {
    switch (findingMethod) {
        case TrackingParams.RECOMMENDATION_REFERER:
            return NavigationListNames.PRODUCT_RECOMMENDATION;
        case TrackingParams.HOMEPAGE_REFERER:
            return NavigationListNames.HOMEPAGE;
        case TrackingParams.BROWSE_REFERER:
            return NavigationListNames.MAIN;
        case TrackingParams.SEARCH_REFERER:
            return NavigationListNames.SEARCH;
        case TrackingParams.CONTENTFUL_REFERER:
            return NavigationListNames.CONTENTFUL;
        case TrackingParams.PRODUCT_CAROUSEL_REFERER:
            return NavigationListNames.RELATED_PRODUCTS;
        default:
            return NavigationListNames.MAIN;
    }
};

export const getNavigationId = (findingMethod: string) => {
    switch (findingMethod) {
        case TrackingParams.RECOMMENDATION_REFERER:
            return NavigationListTypes.PRODUCT_RECOMMENDATION;
        case TrackingParams.HOMEPAGE_REFERER:
            return NavigationListTypes.HOMEPAGE;
        case TrackingParams.BROWSE_REFERER:
            return NavigationListTypes.STANDARD_PLP;
        case TrackingParams.SEARCH_REFERER:
            return NavigationListTypes.SEARCH;
        case TrackingParams.CONTENTFUL_REFERER:
        case TrackingParams.PRODUCT_CAROUSEL_REFERER:
            return NavigationListTypes.PRODUCT_CAROUSEL;
        default:
            return NavigationListTypes.STANDARD_PDP;
    }
};

export type Ga4ItemListAttribution = {
    item_list_id: string;
    item_list_name: string;
    index?: number;
};

export const processFindingMethod = (findingMethod = 'Other') => {
    if (document.referrer) {
        const referrer = new URL(document.referrer);

        if (referrer.origin !== getOrigin()) {
            return TrackingParams.EXTERNAL_REFERER;
        }
    } else {
        return TrackingParams.EXTERNAL_REFERER;
    }

    const fmethod = getQueryStringValue('fmethod');
    if (fmethod) {
        return fmethod;
    }

    const { previousPage } = globalThis.sessionStorage;
    if (previousPage === 'homepage') {
        return TrackingParams.HOMEPAGE_REFERER;
    }

    return findingMethod;
};

export const getGa4ItemListAttributionFromSkuFindingMethod = (skuFindingMethod: string): Ga4ItemListAttribution => {
    const decoded = parseFrefStyleFindingMethod(skuFindingMethod);
    if (decoded) {
        return {
            item_list_id: decoded.item_list_id,
            item_list_name: decoded.item_list_name,
            index: decoded.index,
        };
    }

    const findingMethod = processFindingMethod(skuFindingMethod);
    return {
        item_list_id: getNavigationId(findingMethod),
        item_list_name: getNavigationName(findingMethod),
    };
};
